import gql from 'graphql-tag';

export const DeleteUser = gql`
  mutation DeleteUser($organizationId: ID!, $userId: ID!) {
    deleteUser(organizationId: $organizationId, userId: $userId) {
      id
    }
  }
`;
